/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { AnimatePresence, motion } from 'framer-motion';
import styles from './Header.module.scss';
import SquareLogo from '../../assets/images/square_logo.png';
import TextLogo from '../../assets/images/text_logo.png';
import AppleStoreButton from '../../assets/images/ko_appstore.png';
import GoogleStoreButton from '../../assets/images/ko_googleplay.png';
import { useEffect, useState } from 'react';
import useMobile from '../../hooks/useMobile';

const Header = () => {
  const [visible, setVisible] = useState(true);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [isTop, setIsTop] = useState(true);
  const { isMobile } = useMobile();

  const headerVariants = {
    initial: {
      y: -100,
      opacity: 0,
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 20,
        duration: 0.3,
      },
    },
    exit: {
      y: -100,
      opacity: 0,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 20,
        duration: 0.3,
      },
    },
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isScrollingUp = prevScrollPos > currentScrollPos;

      // 최상단인지 체크
      setIsTop(currentScrollPos < 10);

      // 스크롤 방향에 따라 헤더 표시/숨김 설정
      if (!isTop) {
        setVisible(isScrollingUp);
      }

      setPrevScrollPos(currentScrollPos);
    };

    const handleMouseMove = (e: any) => {
      // 마우스가 화면 상단 50px 이내에 있을 때 헤더 표시
      if (e.clientY <= 50 && !isTop) {
        setVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [prevScrollPos, isTop]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={styles.the_origin_header}
          initial="initial"
          animate="animate"
          exit="exit"
          variants={headerVariants}
        >
          <div className={styles.logo_container}>
            <img
              className={styles.square_logo}
              src={SquareLogo}
              alt="logo"
              onClick={() => {
                scrollToTop();
              }}
            />
            {!isMobile && (
              <img
                className={styles.text_logo}
                src={TextLogo}
                alt="logo"
                onClick={() => {
                  scrollToTop();
                }}
              />
            )}
          </div>
          <div className={styles.store_button_container}>
            <img
              src={AppleStoreButton}
              alt="logo"
              onClick={() => {
                window.open(
                  'https://apps.apple.com/us/app/%ED%8C%8C%EB%A5%B4%ED%8E%98-parfai-%EC%84%A4%EB%A0%98%EC%9D%B4-%EC%8C%93%EC%9D%B4%EB%8A%94-ai-%EC%B1%84%ED%8C%85/id6739119398',
                  '_blank',
                );
              }}
            />
            <img
              src={GoogleStoreButton}
              alt="logo"
              onClick={() => {
                window.open('#', '_blank');
              }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Header;
